import { Component, Input, Output, EventEmitter } from "@angular/core";

import { LexTranslateService } from "@app/core/services/lex-translate.service";
import { Helpers } from "src/app/helpers";

interface Column {
  id: string;
  name: string;
  ngClass?: string;
  classes?: string;
  width?: number;
  truncateLongText?: boolean;
}

@Component({
  selector: "seb-form-table-component",
  templateUrl: "./form-table-component.component.html",
  styleUrls: ["./form-table-component.component.css"],
})
export class FormTableComponent {

  @Input() data: any[];
  @Input() columns: Column[];
  @Input() actionRemove = false;
  @Input() showStatus = false;

  @Output() evRemove = new EventEmitter<any>();

  constructor(public lextranslate: LexTranslateService) {}

  onRemove(index: number, d: any) {
    this.evRemove.emit({ index: index, data: d });
  }

  getStatusColorAndLabel(status) {
    return Helpers.getStatusColorAndLabel(status);
  }

  isArr(item: any) {
    return Array.isArray(item);
  }

  isLongText(value: string, threshold = 15): boolean {
    return typeof value === 'string' && value.length > threshold;
  }
}
